import { IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';

interface Props {
  text: string;
  label?: string;
  className?: string;
}

export default function CopyIconButton({ text, label, className }: Props) {
  if (!text) {
    return null;
  }

  const handleCopy = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    toast.success(`${label || 'Text'} copied to clipboard`);
  };

  return (
    <IconButton
      size="small"
      onClick={handleCopy}
      className={className}
      sx={{
        opacity: 0,
        transition: 'opacity 0.2s ease-in-out',
        ml: 1,
        color: 'var(--mui-palette-primary-main)',
      }}
    >
      <ContentCopyIcon fontSize="small" />
    </IconButton>
  );
}
